import _typeof from "@babel/runtime/helpers/typeof";
var STORE_PREFIX = 'PADDL_LOCAL_DATA_STORE_SERVICE_';
var getStorageKey = function getStorageKey(key) {
  return "".concat(STORE_PREFIX).concat(key);
};
var localStorageCommit = function localStorageCommit(action) {
  try {
    var _localStorage;
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    if (typeof window !== 'undefined') return (_localStorage = localStorage)[action].apply(_localStorage, args);
    return null;
  } catch (e) {
    console.warn("failed to ".concat(action, " error: ").concat(e));
    return null;
  }
};
var validateKey = function validateKey(key, functionName) {
  if (typeof key !== 'string') {
    throw new Error("Invalid key for ".concat(functionName, " key: ").concat(key, " "));
  }
};
var setLocalDataWithKey = function setLocalDataWithKey(key, data) {
  validateKey(key, 'setLocalDataWithKey');
  if (typeof data === 'undefined' || data === null || data === '') {
    throw new Error("no data given to setLocalDataWithKey data: ".concat(_typeof(data), " ").concat(data, " "));
  }
  return localStorageCommit('setItem', getStorageKey(key), data);
};
var getLocallyStoredDataWithKey = function getLocallyStoredDataWithKey(key) {
  validateKey(key, 'getLocallyStoredDataWithKey');
  return localStorageCommit('getItem', getStorageKey(key));
};
var removeLocallyStoredDataWithKey = function removeLocallyStoredDataWithKey(key) {
  validateKey(key, 'removeLocallyStoredDataWithKey');
  return localStorageCommit('removeItem', getStorageKey(key));
};
var removeAllLocalData = function removeAllLocalData() {
  return typeof localStorage === 'undefined' ? undefined : Object.keys(localStorage).filter(function (key) {
    return key.indexOf(STORE_PREFIX) !== -1;
  }).forEach(function (key) {
    return localStorageCommit('removeItem', key);
  });
};

// Define a property that is enabled to be overwritten using a value in local-storage
var overridableLocalData = function overridableLocalData(storageKey, value) {
  var localValue = localStorage.getItem(storageKey);
  if (localValue) {
    console.info("\uD83D\uDE80 Using local override for ".concat(storageKey, " [").concat(localValue, "]"));
  }
  return localValue || value;
};
export { setLocalDataWithKey, getLocallyStoredDataWithKey, removeLocallyStoredDataWithKey, removeAllLocalData, overridableLocalData };